export function isEventStartMissing(
  format: 'micro' | 'zine' | 'book' | 'event' | 'job',
  eventStartsAt: string | null | undefined
): boolean {
  return format === 'event' && !String(eventStartsAt || '').trim()
}

export function isEventEndBeforeStart(
  format: 'micro' | 'zine' | 'book' | 'event' | 'job',
  eventStartsAt: string | null | undefined,
  eventEndsAt: string | null | undefined
): boolean {
  if (format !== 'event') return false
  const startRaw = String(eventStartsAt || '').trim()
  const endRaw = String(eventEndsAt || '').trim()
  if (!startRaw || !endRaw) return false
  const startMs = Date.parse(startRaw)
  const endMs = Date.parse(endRaw)
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return false
  return endMs < startMs
}
